import {
  Combobox,
  ComboboxContent,
  ComboboxTrigger,
} from '@/components/Combobox/Combobox';
import { useMapErinnerungszeitenToFristdatum } from '@/domain/mitarbeiter/shared/hooks/useMapErinnerungszeitenToFristdatum/useMapErinnerungszeitenToFristdatum';
import { useTranslation } from 'react-i18next';

export function ErinnerungsZeitenMultiSelect({
  values,
  handleChange,
  fristdatum,
}: {
  values: string[];
  handleChange: (value: string[]) => void;
  fristdatum?: string;
}) {
  const { t } = useTranslation();
  const options = useMapErinnerungszeitenToFristdatum(fristdatum);
  const selectedValues = options
    .filter((ab) => values.includes(ab.value))
    .map((option) => option.value);

  return (
    <Combobox
      options={options}
      values={selectedValues}
      onValuesChange={handleChange}
      placeholder={t(
        `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.sekundaereArbeitsbereiche.placeholder`,
      )}>
      <ComboboxTrigger />
      <ComboboxContent />
    </Combobox>
  );
}
